var map = {
	"./bevi/img/logo-menu.png": "e709",
	"./br_qualy/img/logo-menu.png": "ca99",
	"./cashme/img/logo-menu.png": "f68c",
	"./cnf/img/logo-menu.png": "f09d",
	"./hyundai/img/logo-menu.png": "10d4",
	"./jcb/img/logo-menu.png": "24a1",
	"./komatsu/img/logo-menu.png": "03f3",
	"./mercedes/img/logo-menu.png": "effe",
	"./portobens/img/logo-menu.png": "0ad3",
	"./rodobens/img/logo-menu.png": "e46a",
	"./royal_enf/img/logo-menu.png": "a885",
	"./tribanco/img/logo-menu.png": "4365"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df1f";